import { render, staticRenderFns } from "./Xssc.vue?vue&type=template&id=1a5c46f6&scoped=true&"
import script from "./Xssc.vue?vue&type=script&lang=js&"
export * from "./Xssc.vue?vue&type=script&lang=js&"
import style0 from "./Xssc.vue?vue&type=style&index=0&id=1a5c46f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c46f6",
  null
  
)

export default component.exports